const Constants = {

  applicationName: 'RansomStop',

  customerName: 'studycenter',
  apiHost: 'studycenter-api',
  domainName: 'ransomstop.com',
  version: '2.3.1',
  userPoolId: 'us-east-1_3n6qnR7K3',
  userPoolClientId: '5rtve9smkd9gau872fdirp3ut4',
  authDomain: 'studycenter-ransomstop-com.auth.us-east-1.amazoncognito.com',
  region: 'us-east-1',
  invokeUrl: '',
  showBilling: false,

}
export default Constants